export class SwalHelper {
    constructor() {
    }
  
    default: any = {
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-primary swal-buttons mx-1',
        cancelButton: 'btn btn-outline-primary swal-buttons mx-1'
      }
    };
    question: any = {
      type: 'question',
      confirmButtonText: 'Evet',
      cancelButtonText: 'Vazgeç',
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-primary swal-buttons mx-1',
        cancelButton: 'btn btn-outline-primary swal-buttons mx-1'
      }
    };
    delete: any = {
      title: 'Bu işlem geri alınamaz!',
      type: 'warning',
      confirmButtonText: 'Onayla',
      cancelButtonText: 'Vazgeç',
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-danger swal-buttons mx-1',
        cancelButton: 'btn btn-outline-primary swal-buttons mx-1'
      }
    };
    success: any = {
      title: 'Başarılı!',
      type: 'success',
      confirmButtonText: 'Tamam',
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-success swal-buttons mx-1',
        cancelButton: 'btn btn-outline-primary swal-buttons mx-1'
      }
    };
    error: any = {
      title: 'Hata!',
      type: 'error',
      confirmButtonText: 'Tamam',
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-primary swal-buttons mx-1',
        cancelButton: 'btn btn-outline-primary swal-buttons mx-1'
      }
    };
    info: any = {
      title: 'Uyarı!',
      type: 'info',
      confirmButtonText: 'Tamam',
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-primary swal-buttons mx-1',
        cancelButton: 'btn btn-outline-primary swal-buttons mx-1'
      }
    };
  
  
  }
  


// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/helpers/swal.helper.ts